module.exports = __webpack_public_path__ + "img/40_38_034_110.d12c1406.jpg";